module.exports = __webpack_public_path__ + "media/images/flags/aq-561695f13ae68c27b7d779405747f058.svg";